import axios from "axios";

const BASE_API = process.env.REACT_APP_API_URL || "http://localhost:3000/api/v1";

const PORTAL_TOKEN_KEY = "tali_guest_portal_token";
const PORTAL_EMAIL_KEY = "tali_guest_portal_email";

export const getPortalToken = () => localStorage.getItem(PORTAL_TOKEN_KEY) || "";
export const getPortalEmail = () => localStorage.getItem(PORTAL_EMAIL_KEY) || "";
export const setPortalSession = (token, email) => {
  localStorage.setItem(PORTAL_TOKEN_KEY, token);
  localStorage.setItem(PORTAL_EMAIL_KEY, email);
};
export const clearPortalSession = () => {
  localStorage.removeItem(PORTAL_TOKEN_KEY);
  localStorage.removeItem(PORTAL_EMAIL_KEY);
};

const portalHeaders = () => {
  const token = getPortalToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const requestOtp = async (email) => {
  const r = await axios.post(`${BASE_API}/guest-portal/request-otp`, { email });
  return r.data;
};

export const verifyOtp = async (email, otp) => {
  const r = await axios.post(`${BASE_API}/guest-portal/verify-otp`, {
    email,
    otp,
  });
  if (r.data?.token) setPortalSession(r.data.token, email);
  return r.data;
};

export const fetchHistory = async () => {
  const r = await axios.get(`${BASE_API}/guest-portal/me/history`, {
    headers: portalHeaders(),
  });
  return r.data;
};

export const fetchUpcomingReservations = async () => {
  const r = await axios.get(
    `${BASE_API}/guest-portal/me/upcoming-reservations`,
    { headers: portalHeaders() },
  );
  return r.data;
};

export const fetchUpcomingEventOrders = async () => {
  const r = await axios.get(`${BASE_API}/guest-portal/me/upcoming-events`, {
    headers: portalHeaders(),
  });
  return r.data;
};

export const createGuestRequest = async (payload) => {
  const r = await axios.post(
    `${BASE_API}/guest-portal/me/requests`,
    payload,
    { headers: portalHeaders() },
  );
  return r.data;
};

export const fetchMyRequests = async () => {
  const r = await axios.get(`${BASE_API}/guest-portal/me/requests`, {
    headers: portalHeaders(),
  });
  return r.data;
};

export const fetchTransferTargets = async (orderId) => {
  const r = await axios.get(
    `${BASE_API}/guest-portal/me/orders/${orderId}/transfer-targets`,
    { headers: portalHeaders() },
  );
  return r.data;
};

export const cancelMyRequest = async (requestId) => {
  const r = await axios.delete(
    `${BASE_API}/guest-portal/me/requests/${requestId}`,
    { headers: portalHeaders() },
  );
  return r.data;
};

export const fetchRescheduleSlots = async (reservationId, date) => {
  const r = await axios.get(
    `${BASE_API}/guest-portal/me/reservations/${reservationId}/available-slots`,
    { headers: portalHeaders(), params: { date } },
  );
  return r.data;
};
